'use client';

import { useEffect, useState } from 'react';
import { useAuth } from '@/platform/auth/useAuth';
import { fetchAdminMe } from './api';

export function useAdmin() {
  const { isAuthenticated, sessionReady } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [portalAdmin, setPortalAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!sessionReady) return;
    if (!isAuthenticated) {
      setIsAdmin(false);
      setPortalAdmin(false);
      setLoading(false);
      return;
    }
    setLoading(true);
    fetchAdminMe()
      .then((res) => {
        setIsAdmin(!!res.isAdmin);
        setPortalAdmin(!!res.portalAdmin);
      })
      .catch(() => {
        setIsAdmin(false);
        setPortalAdmin(false);
      })
      .finally(() => setLoading(false));
  }, [isAuthenticated, sessionReady]);

  return { isAdmin, portalAdmin, loading: !sessionReady || loading };
}
